/* eslint-disable react/no-unescaped-entities */
import React from 'react';

/**
 * 상품리뷰 평가항목 통계
 */
function DealReviewStats({ representReviewSurveyInfos }) {
  return (
    <div className="review_stats">
      <ul className="review_stats_list">
        {representReviewSurveyInfos.map(stat => (
          <li className="review_stats_item" key={stat.keyword}>
            <div className="review_stats_wrap">
              <span className="keyword">{stat.keyword}</span>
              <span className="text">
                "{stat.representSelection.selection}"
              </span>
              {TMON.oApp.sPlatform === 'PW' && (
                <span className="progressbar">
                  <span
                    className="value"
                    style={{ width: `${stat.representSelection.rate}%` }}
                  />
                </span>
              )}
              <span className="pct">{stat.representSelection.rate}%</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DealReviewStats;
